import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Pocket = createReactComponent("Pocket", ["svg", defaultAttributes, [["path", {
  d: "M4 3h16a2 2 0 012 2v6a10 10 0 01-10 10A10 10 0 012 11V5a2 2 0 012-2z",
  key: "1c9ua7"
}], ["polyline", {
  points: "8 10 12 14 16 10",
  key: "1jatan"
}]]]);
export default Pocket;